"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeys = exports.isObject = void 0;
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * isObject({});
 * // => true
 *
 * isObject([1, 2, 3]);
 * // => true
 *
 * isObject(null);
 * // => false
 */
function isObject(value) {
    return (value != null && (typeof value === "object" || typeof value === "function"));
}
exports.isObject = isObject;
function getKeys(obj) {
    return Object.keys(obj);
}
exports.getKeys = getKeys;
